import styled from 'styled-components';
import { COLORS } from '../../../../constants/radar';

export const DescriptionPanel = styled.div`
  padding: ${props => props.$isCollapsed ? '10px' : '20px'};
  max-height: 100vh;
  overflow-y: auto;
  transition: all 0.3s ease;
  width: ${props => props.$isCollapsed ? '50px' : '300px'};
  display: flex;
  flex-direction: column;
`;

export const CollapsedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  gap: 10px;
`;

export const VerticalTitle = styled.div`
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: calc(100% - 40px);
  font-size: 16px;
  font-weight: bold;
`;

export const DescriptionContent = styled.div`
  p {
    margin: 0 0 16px;
    line-height: 1.5;
  }
`;

export const CollapseButton = styled.button`
  background: transparent;
  color: ${COLORS.PRIMARY};
  border: none;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  padding: 0;

  
  &:hover {
    background: ${COLORS.BACKGROUND};
  }

  svg {
    font-size: 14px;
  }
`;

export const ExpandedContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ExpandedHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  
  h2 {
    margin: 8px 0;
    font-size: 20px;
  }
`;

export const CloseButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 4px;
`;

export const ProjectsList = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProjectItem = styled.div`
  padding: 4px 8px;
  background: ${COLORS.PRIMARY}15;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${COLORS.PRIMARY}30;
  height: 24px;
  box-sizing: border-box;
  
  span {
    font-weight: 500;
    color: ${COLORS.PRIMARY};
    font-size: 12px;
  }
  
  small {
    color: ${COLORS.SECONDARY};
    font-size: 12px;
    margin-left: 12px;
  }
`;

export const SectionHeader = styled.h3`
  margin: 16px 0 8px;
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    font-size: 12px;
    color: ${COLORS.SECONDARY};
  }
`;

export const LoadingSpinner = styled.div`
  color: #666;
  font-size: 14px;
  padding: 8px 0;
  font-style: italic;
`;

export const EmptyMessage = styled.div`
  padding: 12px;
  background: #f5f7fa;
  border-radius: 4px;
  color: #666;
  font-style: italic;
  text-align: center;
  border: 1px dashed #ccc;
  margin-top: 8px;
`;

export const TagGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px 0;
`;

export const TagChildren = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 16px;
`;

export const TagItem = styled.span`
  background: ${props => props.$isSelected ? `${COLORS.PRIMARY}15` : 'transparent'};
  color: ${props => props.$isSelected ? COLORS.PRIMARY : COLORS.SECONDARY};
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: ${props => props.$isSelected ? '500' : '400'};
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid ${props => props.$isSelected ? `${COLORS.PRIMARY}30` : 'transparent'};
  width: fit-content;
`;

export const IndirectPrefix = styled.span`
  color: ${COLORS.SECONDARY};
  margin-right: 4px;
`;

export const TagsList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 16px;
`;

export const TagItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
